import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, TextArea } from '@origo/origo-ui';
import type { PlanInfoFormValues, SelectOption } from '../../../types';
import PageSection from '../../../components/PageSection';

interface LawReferenceSectionProps {
    values: Pick<PlanInfoFormValues, 'lovreferanse' | 'beskrivelse'>;
    lovreferanseOptions: SelectOption[];
    errors?: Partial<Record<'lovreferanse', string>>;
    onChange: (field: 'lovreferanse' | 'beskrivelse', value: string) => void;
}

const MAX_BESKRIVELSE = 120;

const LawReferenceSection: React.FC<LawReferenceSectionProps> = ({
    values,
    lovreferanseOptions,
    errors = {},
    onChange,
}) => {
    const { t } = useTranslation();

    return (
        <PageSection title={t('planInfo.sections.lawRef')} asFieldset>
            <Select
                label={t('planInfo.fields.lovreferanse')}
                placeholder={t('planInfo.fields.lovreferansePlaceholder')}
                value={values.lovreferanse}
                error={errors.lovreferanse}
                onChange={e => onChange('lovreferanse', e.target.value)}
                options={lovreferanseOptions}
            />
            <TextArea
                label={t('planInfo.fields.beskrivelse')}
                helperText={t('planInfo.fields.beskrivelseHelp')}
                placeholder={t('planInfo.fields.beskrivelsePlaceholder')}
                value={values.beskrivelse}
                onChange={e => onChange('beskrivelse', e.target.value.slice(0, MAX_BESKRIVELSE))}
                maxLength={MAX_BESKRIVELSE}
                rows={3}
            />
        </PageSection>
    );
};

export default LawReferenceSection;
